import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useFetch from "../../Hooks/useFetch";
import Teachers from "../../Templates/Teachers/Teachers";
import { schoolListURL, teacherURL } from "../../Hooks/URL";
import { userContext } from "../../Contexts/userContext";

function TeachersPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(9);
  const [totalCount, setTotalCount] = useState(0);
  const [searchData, setSearchData] = useState("");
  const [search, setSearch] = useState("");
  const [Filter, setFilter] = useState("");
  const [sort, setSort] = useState("");
  const [teachers, setTeachers] = useState([]);
  const { data, loading, error } = useFetch(
    teacherURL,
    page,
    rowsPerPage,
    search,
    null,
    null,
    `${sort}${Filter}`
  );

  useEffect(() => {
    if (!loading && !error && data) {
      setTeachers(data?.data?.data?.rows);
      setPageCount(data?.data?.data?.numberOfPages);
      setTotalCount(data?.data?.data?.totalCount);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "instructors", data: "" });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Teachers
      role={contextData?.role}
      page={page}
      rowsPerPage={rowsPerPage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      searchData={searchData}
      search={search}
      setSearchData={setSearchData}
      setSearch={setSearch}
      teachers={teachers}
      navigate={navigate}
      handleChangePage={handleChangePage}
      loading={loading}
      data={data}
      error={error}
      pageCount={pageCount}
      setTeachers={setTeachers}
      setFilter={setFilter}
      totalCount={totalCount}
      setSort={setSort}
      currentSort={sort}
    />
  );
}

export default TeachersPage;
